import React, { useState, useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Divider, CircularProgress, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { firstDayofYear, lastDayofYear } from '../../utils/calcDatetime';
import * as yup from 'yup';
import dayjs from 'dayjs';
import * as xlsx from 'xlsx';
import * as projectApi from '../../lib/api/project';
import { SearchBox } from '../../components/forecastmonthstat/SearchBox';
import { prjImpts } from '../../utils/forecastMonthStaticData';
import ForecastMonthStateTable from '../../components/forecastmonthstat/ForecastMonthStateTable';

const ForecastMonthStatContainer = () => {
  const tableRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchPrjTyp, setSearchPrjTyp] = useState('all');
  const [searchStrtDt, setSearchStrtDt] = useState(firstDayofYear);
  const [searchEndDt, setSearchEndDt] = useState(lastDayofYear);

  const handleDownExcel = () => {
    const el = tableRef;
    const name = '중요도별 통계';
    //console.log('handleDownload click')
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  //   useEffect(() => {
  //     searchList(formik.values);
  //   }, []);

  const searchList = async (values) => {
    setLoading(true);
    const startDate =
      values.searchStrtDt !== null && values.searchStrtDt !== ''
        ? dayjs(values.searchStrtDt).format('YYYY-MM-DD')
        : '';
    const endDate =
      values.searchEndDt !== null && values.searchEndDt !== ''
        ? dayjs(values.searchEndDt).format('YYYY-MM-DD')
        : '';

    let searchData = {
      prjTyp: values.searchPrjTyp,
      strtDt: startDate,
      endDt: endDate,
    };

    setSearchStrtDt(values.searchStrtDt);
    setSearchEndDt(values.searchEndDt);

    //try~catch async
    // const tempData = makeDataForecastMonth();
    // setData(tempData);
    try {
      const res = await projectApi.getProjectsMonthSummary(searchData);
      if (res.data) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }

    setLoading(false);
  };

  const initialValues = {
    searchPrjTyp: searchPrjTyp,
    searchStrtDt: searchStrtDt,
    searchEndDt: searchEndDt,
  };

  const validationSchema = yup.object({
    searchStrtDt: yup.date().nullable().default(undefined),
    searchEndDt: yup
      .date()
      .min(yup.ref('searchStrtDt'), '검색 종료일을 확인하세요')
      .when('searchStrtDt', (searchStrtDt, schema) => {
        if (searchStrtDt) return schema.required('검색 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        searchList(values);
        setSubmitting(false);
      }, 1000);
    },
  });

  useEffect(() => {
    if (formik.values?.searchPrjTyp) {
      searchList(formik.values);
    }
  }, [formik?.values?.searchPrjTyp]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 1 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <SearchBox formik={formik} handleDownExcel={handleDownExcel} />
      </Box>
      <Divider sx={{ my: 1 }} />

      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {loading ? (
          <Box sx={{ display: 'flex' }}>
            <CircularProgress />
          </Box>
        ) : Array.isArray(data) && data.length === 0 ? (
          <Box>
            <Typography variant="subtitle2">데이터가 없습니다.</Typography>
          </Box>
        ) : (
          <ForecastMonthStateTable
            headerRows={prjImpts}
            tableRef={tableRef}
            data={data}
          />
        )}
      </Box>
    </Box>
  );
};

export default ForecastMonthStatContainer;
